import { render, staticRenderFns } from "./UiCategories.vue?vue&type=template&id=0aab2edf"
import script from "./UiCategories.vue?vue&type=script&lang=js"
export * from "./UiCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports